import React from "react";
import DoneOutlinedIcon from '@mui/icons-material/DoneOutlined';
import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined';

const StatusIcon = (props) => {

    let icon = '';
    const message = props?.message ?? '';

    switch (props.status) {
        case 'success':
            icon = <DoneOutlinedIcon color="success" sx={{ marginLeft: 2 }} aria-label={message} />;
            break
        case 'disabled':
            icon = <DoneOutlinedIcon color="disabled" sx={{ marginLeft: 2 }} aria-label={message} />;
            break
        case 'warning':
            icon = <WarningAmberOutlinedIcon color="warning" sx={{ marginLeft: 2 }} aria-label={message} />;
            break
        case 'error':
            icon = <WarningAmberOutlinedIcon color="error" sx={{ marginLeft: 2 }} aria-label={message} />;
            break
        case 'info':
            icon = <DoneOutlinedIcon color="disabled" sx={{ marginLeft: 2 }} aria-label={message} />;
            break

        default:
            break
    }

    return (icon);

}

export default StatusIcon;